/**
 * RFC 0345 3h on a Mac: this window holds no keys and no account sign-in, so
 * its daemon sends a session's invites. The desktop tab repo registers how to
 * ask it; anywhere else nothing is registered and Share stays as it was.
 */

export type DesktopInvite = (input: {
  sessionId: string
  email: string
  level: 'edit' | 'read'
  agentReach?: 'session' | 'full'
}) => Promise<{ link: string }>

/** Who can see a session, as the daemon reads its signed grants (3i). */
export type DesktopMembers = (sessionId: string) => Promise<unknown[]>

let desktopInvite: DesktopInvite | undefined
let desktopMembers: DesktopMembers | undefined

export function setDesktopInvite(
  invite: DesktopInvite | undefined,
  members?: DesktopMembers,
): void {
  desktopInvite = invite
  desktopMembers = invite ? members : undefined
}

export function desktopMembersFor(): DesktopMembers | undefined {
  return desktopMembers
}

export function desktopInviteFor(): DesktopInvite | undefined {
  return desktopInvite
}
